// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2043": "a43c1500","277": "72c6b240","5262": "dfef6b57","9988": "b78b2a24",}[chunkId] + ".css"
}